@if (wishlistCarouselItem() && model().isOutOfStock) {
<div class="fill bg-col-w z-3"
     style="opacity:0.7;"></div>
}
<!-- Main image for desktop (non-touch) -->
@if (showCarouselOnHover()) {
<div class="fill">
    <ng-container *ngTemplateOutlet="alternativeImagesTpl; context: { item: {
            image: primaryImage(),
            video: primaryVideo()
          }, priority: priority() }" />
</div>
}
<!-- Carousel for hover (desktop) or always visible (mobile) -->
<ul class="_images"
    [class._carousel]="showCarouselOnHover() || showCarouselAlways()"
    [class._carousel-hover]="showCarouselOnHover() && !canShowAlternativeImages()"
    [style.--carousel-images]="alternativeImagesLength() + 1"
    #carouselRef>
    @if (!showCarouselOnHover()) {
    <li>
        <ng-container *ngTemplateOutlet="alternativeImagesTpl; context: { item: {
            image: primaryImage(),
            video: primaryVideo()
          }, priority: priority() }" />
    </li>
    }
    @if (canShowAlternativeImages()) {
    <li class="_hover">
        <ng-container
                      *ngTemplateOutlet="alternativeImagesTpl; context: { item: alternativeImages()[0], priority: false }" />
    </li>
    } @else {
    @if (canShowCarousel()) {
    @for (image of alternativeImages(); track $index) {
    <li>
        <ng-container *ngTemplateOutlet="alternativeImagesTpl; context: { item: image, priority: false }" />
    </li>
    }
    }
    }
</ul>
<div class="carousel-dots"
     [class.ng-hide]="!(showCarouselOnHover() || showCarouselAlways())"
     [style.--carousel-dots-number]="dots().length">
    <div class="carousel-dots-inner">
        @for (bullet of dots(); track $index) {
        <button class="carousel-dot"
                [class.is-active]="!$index"
                type="button"
                [attr.aria-label]="'Go to slide %' | translate : ($index + 1)"
                (click)="scrollToIndex($index)"></button>
        }
        <div class="carousel-dots-underbar"></div>
    </div>
</div>
@if (alternativeImagesLength() > 1 && !isTouchDevice()) {
<div class="carousel-nav">
    <button class="p-a-2 opacity-0 carousel-prev"
            type="button"
            [aria-label]="'Previous slide' | translate"
            (click)="prev()">
        <i class="col-1 fs-3 icon-wrap icon-chevron-left"
           aria-hidden="true"></i>
    </button>
    <button class="p-a-2 carousel-next"
            type="button"
            [aria-label]="'Next slide' | translate"
            (click)="next()">
        <i class="col-1 fs-3 icon-wrap icon-chevron-right"
           aria-hidden="true"></i>
    </button>
</div>
}

<ng-template #alternativeImagesTpl
             let-item="item"
             let-priority="priority">
    <href class="fill overflow-hidden"
          [hrefClass]="'fill'"
          [link]="hrefLink()"
          [gtmTrackSelectItem]="gtmTrackSelectItem()"
          [gtmTrackSelectItemOff]="client.isCms"
          [klevuTrackCategoryProductClick]="klevuCategoryProductTrackClick()"
          [klevuTrackClick]="klevuSearchTrackClick()">
        <df-image-wrapper class="fill">
            <img class="z-1"
                 [class]="model().isLandscapeListingView ? 'w-12 flex flex-grow' : ''"
                 [dfImage]="item.image"
                 [ratio]="model().isLandscapeListingView | aspectRatio : gridRowSpan() : gridColumn()"
                 [sizes]="sizes()"
                 [alt]="model().productName"
                 [minSize]="256"
                 [maxSize]="1080"
                 [priority]="priority"
                 [placeholder]="false"
                 draggable="false"
                 fill>
        </df-image-wrapper>
        @if (item.video) {
        @defer (on viewport) {
        <local-vimeo-player class="fill z-2"
                            [class]="isVideoBuffered() && isPlaying() ? '' : 'opacity-0'"
                            [video-id]="item.video"
                            [autopause]="false"
                            [background]="true"
                            [pauseOnInit]="true"
                            [loop]="false"
                            [controls]="false"
                            [use-custom-controls]="true"
                            [playerIdentifier]="playerIdentifier()"
                            (onPlayerInit)="onPlayerInit($event)"
                            (onVideoEnd)="onVideoEnd()"
                            (onBufferEnd)="onBufferEnd()" />
        } @placeholder {
        <div class="fill z-3"></div>
        }
        }
    </href>
</ng-template>